import React from "react";

/**
 * Handles change of font type for text block.
 *
 * @param {string}   view     String for mobile or desktop view
 * @param {Object}   canvas   FabricJS Canvas Object
 *
 * @returns {Object}
 */
export default function Font({ view, canvas }) {
  const updateFont = () => {
    const className = view == "mobile"
      ? ".details-container-mobile"
      : ".details-container-inner";
    const font = document.querySelectorAll(className + " #fontFamily")[0] || null;
    const activeObject = canvas.getActiveObject() || null;
    if (activeObject === null || font === null) {
      return;
    }
    activeObject.set('fontFamily', font.value);
    canvas.renderAll();
  }

  return (
    <div id="fontTool" className="text-tool-inner">
      <label htmlFor="fontFamily">Font</label>
      <select id="fontFamily" onChange={() => updateFont()}>
        <option value="Arial" defaultValue="selected">Arial</option>
        <option value="Helvetica">Helvetica</option>
        <option value="Myriad Pro">Myriad Pro</option>
        <option value="Verdana">Verdana</option>
        <option value="Georgia">Georgia</option>
        <option value="Courier">Courier</option>
        <option value="Comic Sans">Comic Sans</option>
        <option value="Impact">Impact</option>
      </select>
    </div>
  );
}
